@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css";

/* src/app/front-layout/location/gcse-location/gcse-location.component.css */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family:
    "Segoe UI",
    Tahoma,
    Geneva,
    Verdana,
    sans-serif;
  line-height: 1.6;
  color: #333;
  background: #f5f5f5;
}
.page-wrapper {
  min-height: 100vh;
  padding-bottom: 50px;
}
.page-header {
  background:
    linear-gradient(
      135deg,
      #00729d 0%,
      #005a7d 100%);
  color: white;
  padding: 100px 20px 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.page-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg width="100" height="100" xmlns="http://www.w3.org/2000/svg"><circle cx="50" cy="50" r="2" fill="rgba(255,255,255,0.1)"/></svg>');
  opacity: 0.3;
}
.page-header h1 {
  margin-top: 50px;
  font-size: 3.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  position: relative;
  z-index: 1;
  color: white;
}
.page-header p {
  font-size: 1.5rem;
  opacity: 0.95;
  position: relative;
  z-index: 1;
}
.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
}
.search-section {
  background: white;
  padding: 40px;
  margin: -50px auto 50px;
  border-radius: 12px;
  box-shadow: 0 5px 25px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 10;
  max-width: 1200px;
}
.search-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  align-items: center;
}
.search-box {
  flex: 1;
  min-width: 300px;
  position: relative;
}
.search-box input {
  width: 100%;
  padding: 18px 50px 18px 25px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  font-size: 1.1rem;
  transition: all 0.3s ease;
}
.search-box input:focus {
  outline: none;
  border-color: #00729d;
  box-shadow: 0 0 0 3px rgba(0, 114, 157, 0.1);
}
.search-box i {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  color: #00729d;
  font-size: 1.3rem;
}
.filter-buttons {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-btn {
  padding: 15px 30px;
  border: 2px solid #00729d;
  background: white;
  color: #00729d;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 600;
  font-size: 1.05rem;
  transition: all 0.3s ease;
}
.filter-btn:hover,
.filter-btn.active {
  background: #00729d;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 114, 157, 0.3);
}
.stats-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 25px;
  margin-bottom: 60px;
}
.stat-card {
  background: white;
  padding: 40px 30px;
  border-radius: 12px;
  text-align: center;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
  border-top: 5px solid #ffbf00;
  transition: transform 0.3s ease;
}
.stat-card:hover {
  transform: translateY(-5px);
}
.stat-card i {
  font-size: 3rem;
  color: #00729d;
  margin-bottom: 20px;
}
.stat-card h3 {
  font-size: 2.5rem;
  color: #00729d;
  margin-bottom: 10px;
  font-weight: 700;
}
.stat-card p {
  color: #666;
  font-size: 1.2rem;
  font-weight: 500;
}
.locations-container {
  display: grid;
  grid-template-columns: 1fr 550px;
  gap: 30px;
  margin-bottom: 50px;
  align-items: start;
}
.locations-list-wrapper {
  display: flex;
  flex-direction: column;
}
.results-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  padding: 20px 25px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}
.results-count {
  font-size: 1.3rem;
  color: #00729d;
  font-weight: 700;
}
.sort-dropdown {
  padding: 12px 20px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  background: white;
  color: #333;
  cursor: pointer;
  font-size: 1.05rem;
  font-weight: 500;
}
.sort-dropdown:focus {
  outline: none;
  border-color: #00729d;
}
.locations-list {
  display: flex;
  flex-direction: column;
  gap: 25px;
}
.location-card {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  cursor: pointer;
  display: flex;
  min-height: 240px;
}
.location-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 114, 157, 0.2);
}
.location-image {
  width: 280px;
  min-height: 240px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}
.location-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}
.location-card:hover .location-image img {
  transform: scale(1.1);
}
.location-badge {
  position: absolute;
  top: 15px;
  right: 15px;
  background: #ffbf00;
  color: #00729d;
  padding: 8px 18px;
  border-radius: 25px;
  font-weight: 700;
  font-size: 0.95rem;
}
.location-content {
  flex: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.location-header {
  margin-bottom: 18px;
}
.location-title {
  font-size: 2.5rem;
  color: #00729d;
  margin-bottom: 10px;
  font-weight: 700;
}
.location-details {
  font-size: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 18px;
}
.detail-item {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #555;
  font-size: 1.5rem;
}
.detail-item i {
  color: #00729d;
  width: 20px;
  font-size: 1.5rem;
}
.location-services {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 18px;
}
.service-tag {
  background: #f0f8fb;
  color: #00729d;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 1.5rem;
  font-weight: 600;
}
.location-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #f0f0f0;
}
.view-details-btn {
  background: #00729d;
  color: white;
  padding: 14px 30px;
  border-radius: 30px;
  text-decoration: none;
  font-weight: 600;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.view-details-btn:hover {
  background: #005a7d;
  transform: translateX(5px);
}
.view-details-btn i {
  font-size: 1rem;
}
.distance {
  color: #00729d;
  font-weight: 700;
  font-size: 1.05rem;
}
.map-wrapper {
  position: sticky;
  top: 20px;
  height: calc(100vh - 40px);
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.1);
}
.map-container {
  width: 100%;
  height: 100%;
}
.map-container iframe {
  width: 100%;
  height: 100%;
  border: none;
}
.empty-state {
  text-align: center;
  padding: 80px 20px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}
.empty-state i {
  font-size: 5rem;
  color: #00729d;
  margin-bottom: 25px;
  opacity: 0.5;
}
.empty-state h3 {
  color: #00729d;
  font-size: 1.8rem;
  margin-bottom: 15px;
  font-weight: 700;
}
.empty-state p {
  color: #666;
  font-size: 1.1rem;
}
@media (max-width: 1200px) {
  .locations-container {
    grid-template-columns: 1fr;
  }
  .map-wrapper {
    display: none;
  }
}
@media (max-width: 768px) {
  .page-header {
    padding: 80px 20px 60px;
  }
  .page-header h1 {
    font-size: 2.5rem;
  }
  .page-header p {
    font-size: 1.2rem;
  }
  .search-section {
    padding: 25px;
    margin: -40px auto 40px;
  }
  .search-container {
    flex-direction: column;
  }
  .search-box {
    width: 100%;
    min-width: 100%;
  }
  .filter-buttons {
    width: 100%;
    justify-content: center;
  }
  .filter-btn {
    padding: 12px 20px;
    font-size: 1rem;
  }
  .location-card {
    flex-direction: column;
    height: auto;
  }
  .location-image {
    width: 100%;
    height: 220px;
    min-height: 220px;
  }
  .location-content {
    padding: 25px;
  }
  .location-title {
    font-size: 1.5rem;
  }
  .stats-section {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
  }
  .stat-card {
    padding: 30px 20px;
  }
  .stat-card h3 {
    font-size: 2rem;
  }
  .stat-card p {
    font-size: 1rem;
  }
  .results-info {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
  .results-count {
    font-size: 1.2rem;
  }
  .sort-dropdown {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .page-header h1 {
    font-size: 2rem;
  }
  .page-header p {
    font-size: 1rem;
  }
  .stats-section {
    grid-template-columns: 1fr;
  }
  .location-footer {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }
  .view-details-btn {
    width: 100%;
    justify-content: center;
  }
  .detail-item {
    font-size: 0.95rem;
  }
  .service-tag {
    font-size: 0.85rem;
    padding: 6px 12px;
  }
}
/*# sourceMappingURL=gcse-location.component.css.map */
